/**
 * Off-screen but announced: text that gives a control or heading the name a screen reader
 * needs, where the design carries the same meaning visually by other means.
 */
const visuallyHiddenSx = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  border: 0,
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap',
};

export { visuallyHiddenSx };
